import { Directive, Input, OnInit } from '@angular/core';
import { Role } from '../interfaces/role';
import * as _ from 'lodash';
import { NavItem } from '../interfaces/navItem';
import { RoleService } from '../services/role.service';
import { PermissionRole } from '../resources/permission-role';

@Directive({
    selector: '[role-access]'
})
export class RoleAccessDirective implements OnInit {

    @Input() navItem: NavItem;
    @Input() navItemChildren: NavItem;
    @Input() permissionModule: string;
    @Input() permissionName: string;
    roleUser: Role;

    constructor(
        private roleService: RoleService,
        private permissionRole: PermissionRole
    ) {
    }

    ngOnInit() {


    }

    // tslint:disable-next-line: use-lifecycle-interface
    ngAfterViewInit() {
        this.roleUser = this.roleService.getRoleUser();
        this.permissionByItemNav();
    }

    permissionByItemNav() {
        this.navItem.childrens.map((children, i) => {
            if (Array.isArray(children.name))
                children.visible = children.name.some(name => this.permissionRole.hasPermission(this.navItem.name, name));
            else
                children.visible = this.permissionRole.hasPermission(this.navItem.name, children.name);
        });
        this.navItem.visible = this.navItem.childrens.some(elm => elm.visible)
    }

}
